import"client-only";import{useRef as r}from"react";const t=t=>{const n=r();return n.current||(n.current=t()),n};export{t as useSingleton};